export default __webpack_public_path__ + "static/media/safe7-intro-pa.57c8a66c.png";